module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("aqfCd"))).then(() => parcelRequire('6fKY8'));